import { render, staticRenderFns } from "./pannel.vue?vue&type=template&id=b9d032f4&scoped=true&"
import script from "./pannel.vue?vue&type=script&lang=js&"
export * from "./pannel.vue?vue&type=script&lang=js&"
import style0 from "./pannel.vue?vue&type=style&index=0&id=b9d032f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d032f4",
  null
  
)

export default component.exports